import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AuthzService from 'garaje/services/authz';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import { Permission } from 'garaje/utils/ui-permissions';

export default class LocationOverviewApprovalsRoute extends Route {
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare authz: AuthzService;

  beforeModel(): void {
    const hasPermissions = this.authz.hasAnyPermissionAtCurrentCompany([
      Permission.VISITORS_INVITE_VISUAL_COMPLIANCE_APPROVAL_REVIEW,
      Permission.VISITORS_ENTRY_VISUAL_COMPLIANCE_APPROVAL_REVIEW,
      Permission.VISITORS_INVITE_BLOCKLIST_APPROVAL_REVIEW,
      Permission.VISITORS_ENTRY_BLOCKLIST_APPROVAL_REVIEW,
      Permission.VISITORS_INVITE_APPROVAL_REQUIRED_REVIEW,
      Permission.VISITORS_INVITE_AVA_APPROVAL_REVIEW,
      Permission.VISITORS_ENTRY_AVA_APPROVAL_REVIEW,
    ]);

    if (!this.featureFlags.isEnabled('visitors-global-invite-approvals') || !hasPermissions) {
      void this.router.transitionTo('location-overview.invite-log');
    }
  }
}
